import { ChangeDetectionStrategy, Component, Input } from '@angular/core';


@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-content-wrapper',
    templateUrl: './content-wrapper.component.html',
    styleUrls: ['./content-wrapper.component.scss'],
    standalone: false
})
export class ContentWrapperComponent {
    /**
     * Horizontal alignment class
     */
    @Input() classPx: string = 'px-4 px-md-8';
    /**
     * Vertical padding class
     */
    @Input() classPy: string = 'py-8';
    /**
     * Additional class for col
     */
    @Input() colAdditionalClass: string;
}
